<div class="grid">
  <div class="col-6 field-set-container">
    <p-fieldset [legend]="'COMMON.CONNECTED_USER' | translate">
      <div class="col-12" *ngIf="currentUser">
        <div class="grid">
          <div class="col-12">{{ 'COMMON.CUSTOMERID' | translate }} : {{ currentUser.idCustomer }}</div>
          <div class="col-12">{{ 'COMMON.USERID' | translate }} : {{ currentUser.idUser }}</div>
          <div class="col-12">{{ 'COMMON.USERNAME' | translate }}
            : {{ currentUser.lastName + ' ' + currentUser.firstName }}
          </div>
          <div class="col-12">{{ 'COMMON.LAST_CONNECT' | translate }} : {{ currentUser.lastConnection }}</div>
        </div>
      </div>
    </p-fieldset>
  </div>

  <div class="col-6 " *ngIf="!isAdminNumen">
    <div class="col-12 field-set-container" *ngIf="impersonated">
      <p-fieldset [legend]="'COMMON.IMPERSONATED' | translate">
        <div class="col-12" *ngIf="impersonatedConfLoding">
          <div class="col-12 spinner-container">
            <p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
          </div>
          <div class="col-12">{{ 'COMMON.LOADING_IMPER_CONF' | translate }}</div>
        </div>
        <div class="col-12">{{ 'COMMON.TERMINATE_IMPER' | translate }}</div>
        <div class="col-12">
          <div class="col-8"></div>
          <div class="col-4">
            <button pButton type="button" [icon]="'fa fa-sign-out'" [label]="'COMMON.CLOSE' | translate"
                    [iconPos]="'left'" id="endImpersonateAction"
                    (click)="terminateImpersonate()" [disabled]="!impersonated"
                    class="p-button-danger"></button>
          </div>
        </div>
      </p-fieldset>
    </div>
  </div>
  <div class="col-6 field-set-container" *ngIf="isAdminNumen">

  </div>

</div>

<p-tabView [(activeIndex)]="activeIndex">
  <p-tabPanel [header]="'CONFIGURATION_COMPONENT.CHANGE_MOD_TITLE' | translate">
    <div class="grid" *ngIf="isAdminNumen">
      <div class="col-6">
        <p-fieldset [legend]="'CONFIGURATION_COMPONENT.CHANGE_MOD_TITLE_GLOBAL' | translate">
          <app-mod></app-mod>
        </p-fieldset>
      </div>
      <div class="col-6">
        <p-fieldset
          [legend]="('CONFIGURATION_COMPONENT.CHANGE_MOD_TITLE_CUSTOMER' | translate) + ': ' + currentUser.idCustomer">
          <app-mod [idCustomer]="currentUser.idCustomer"></app-mod>
        </p-fieldset>
      </div>
    </div>
    <div *ngIf="!isAdminNumen">
      {{ 'CONFIGURATION_COMPONENT.CONTENT_NOT_AUTHORIZED' | translate }}
    </div>

  </p-tabPanel>

  <p-tabPanel [header]="'CONFIGURATION_COMPONENT.CHANGE_CONFIGURATION_TITLE' | translate">
    <button pButton type="button" (click)="resetApplication()"
            [label]="'CONFIGURATION_COMPONENT.RESET_PARAMS_BUTTON_LABEL' | translate" class="p-button-danger"></button>
  </p-tabPanel>

  <p-tabPanel [header]="'CONFIGURATION_COMPONENT.CHANGE_PASSWORD_TITLE' | translate">
    <div *ngIf="!isWsoRegistered">
      <div class="grid">
        <div class="col-4 col-offset-4">
          <h3>{{ 'CONFIGURATION_COMPONENT.LABEL_CURRENTPASSWORD' | translate }}</h3>
        </div>
        <div class="col-4 col-offset-4">
          <form>
            <input type="password" pPassword [feedback]="false" [(ngModel)]="actualPassword" name="actualPassword"
                   autocomplete="false">
          </form>
        </div>
      </div>
      <app-create-password (passwordEvent)="newPassword=$event" (verifyPasswordEvent)="verifyPassword=$event"
                           (isNewPasswordValid)="isNewPasswordValid=$event"
                           (isNewPasswordConfirmValid)="isNewPasswordConfirmValid=$event"></app-create-password>
      <div class="grid">
        <div class="col-12 center">
          <button pButton type="button" (click)="changePassword()" [label]="'COMMON.VALIDATE' | translate"
                  [disabled]="!formIsComplete()" class="p-button-warning"></button>
        </div>
      </div>

      <div class="error">
        <div class="grid">
          <p *ngIf="changePasswordFail">{{ errorMessage }}</p>
          <p *ngIf="!isNewPasswordValid">{{ passwordInvalidMsg }}</p>
          <p *ngIf="!isNewPasswordConfirmValid">{{ passwordConfirmInvalidMsg }}</p>
        </div>
      </div>
    </div>
    <div *ngIf="isWsoRegistered">
      <span class="p-text-secondary block h-6rem justify-content-center align-content-center mb-2" [style]="{ color: 'black', 'font-size': '0.85rem', 'text-align': 'center'}">
            {{'WSO2_DETECTED_COMPONENT.WSO2_HAS_TO_BE_REDIRECT_FOR_PWD_RESET_ERROR_MESSAGE_PART_1' | translate}}<br><br>
        {{'WSO2_DETECTED_COMPONENT.WSO2_HAS_TO_BE_REDIRECT_FOR_PWD_RESET_ERROR_MESSAGE_PART_2' | translate}}
        <strong>{{'WSO2_DETECTED_COMPONENT.WSO2_HAS_TO_BE_REDIRECT_FOR_PWD_RESET_ERROR_MESSAGE_PART_3' | translate}}</strong>
        {{'WSO2_DETECTED_COMPONENT.WSO2_HAS_TO_BE_REDIRECT_FOR_PWD_RESET_ERROR_MESSAGE_PART_4' | translate}}
        </span>

    </div>
  </p-tabPanel>

  <p-tabPanel [header]="'CONFIGURATION_COMPONENT.FEATURES_MANAGEMENT_TITLE' | translate"
              *ngIf="isAdminNumen || isAdminExpress || isAdminEmail || isAdminErl">
    <div class="grid">
      <div class="col-12">
        <div class="col-12 mb-4 mt-1 justify-content-center align-center">
          <div class="col-12 justify-content-center align-center">
            <!--<label for="feature" [style]="{'font-weight': 'bold'}">{{ 'CONFIGURATION_COMPONENT.FEATURES_DROPDOWN_LABEL' | translate }}</label>-->
            <h3>{{ 'CONFIGURATION_COMPONENT.FEATURES_DROPDOWN_LABEL' | translate }}</h3>
          </div>
          <div class="col-12 justify-content-center align-center">
            <p-dropdown id="feature" [options]="features" [(ngModel)]="selectedFeature"
                        [editable]="false" optionLabel="name" [style]="{width: '30%'}" class="align-left"></p-dropdown>
          </div>
        </div>
        <app-express-config
          *ngIf="activeIndex === 3 && selectedFeature.id == 1 && (this.isAdminExpress || this.isAdminNumen)"></app-express-config>
        <app-erl-config
          *ngIf="activeIndex === 3 && selectedFeature.id == 2 && (this.isAdminErl || this.isAdminNumen)"></app-erl-config>
        <app-email-config
          *ngIf="activeIndex === 3 && selectedFeature.id == 3 && (this.isAdminEmail || this.isAdminNumen)"></app-email-config>
      </div>
    </div>
    <div class="grid" *ngIf="!isAdminNumen && !isAdminExpress">
      <div class="col-12">
        {{ 'CONFIGURATION_COMPONENT.CONTENT_NOT_AUTHORIZED' | translate }}
      </div>
    </div>
  </p-tabPanel>

  <p-tabPanel [header]="'CONFIGURATION_COMPONENT.IMPERSONATION_TITLE' | translate">
    <div class="grid" *ngIf="isAdminNumen">
      <app-impersonation *ngIf="activeIndex === 4"
                         (userImpersonated)="handleUserImpersonated($event)"></app-impersonation>
    </div>
    <div class="grid" *ngIf="!isAdminNumen">
      {{ 'CONFIGURATION_COMPONENT.CONTENT_NOT_AUTHORIZED' | translate }}
    </div>
  </p-tabPanel>

  <p-tabPanel [header]="'CONFIGURATION_COMPONENT.PURGE_CONFIG_TITLE' | translate">
    <div class="grid" *ngIf="isAdminNumen">
      <div class="col-12">
        <app-purge-config *ngIf="activeIndex === 5"></app-purge-config>
      </div>
    </div>
    <div class="grid" *ngIf="!isAdminNumen">
      <div class="col-12">
        {{ 'CONFIGURATION_COMPONENT.CONTENT_NOT_AUTHORIZED' | translate }}
      </div>
    </div>
  </p-tabPanel>
</p-tabView>













